var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.33936C4.11758 1.33936 1.375 4.08193 1.375 7.46436C1.375 10.8468 4.11758 13.5894 7.5 13.5894C10.8824 13.5894 13.625 10.8468 13.625 7.46436C13.625 4.08193 10.8824 1.33936 7.5 1.33936ZM7.0625 4.51123C7.0625 4.45107 7.11172 4.40186 7.17188 4.40186H7.82812C7.88828 4.40186 7.9375 4.45107 7.9375 4.51123V8.22998C7.9375 8.29014 7.88828 8.33936 7.82812 8.33936H7.17188C7.11172 8.33936 7.0625 8.29014 7.0625 8.22998V4.51123ZM7.5 10.5269C7.32827 10.5233 7.16476 10.4527 7.04455 10.33C6.92434 10.2073 6.85701 10.0424 6.85701 9.87061C6.85701 9.69884 6.92434 9.53392 7.04455 9.41123C7.16476 9.28854 7.32827 9.21786 7.5 9.21436C7.67173 9.21786 7.83524 9.28854 7.95545 9.41123C8.07566 9.53392 8.14299 9.69884 8.14299 9.87061C8.14299 10.0424 8.07566 10.2073 7.95545 10.33C7.83524 10.4527 7.67173 10.5233 7.5 10.5269Z",
    fill: "#FAAD14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamationCircle.07b17ff133fd0f1b4f773eea986bbaa2.svg";
export { ForwardRef as ReactComponent };